function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "i1nkknq3ta",
  d: "M48.386 0L0 0 0 79.4 48.386 79.4z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#EF6937",
  fillRule: "nonzero",
  opacity: 0.2
}, /*#__PURE__*/React.createElement("path", {
  d: "M40.086 133.642c14.092 17.677 25.485 11.617 41.99 21.977 9.407 5.902 15.91 18.2 29.14 17.234 9.95-.73 18.998-8.292 23.458-16.861 2.083-4.003 1.797-10.04 4.067-13.746 4.686-7.645 12.422-9.512 19.828-14.419 8.535-5.66 15.473-12.925 14.92-24.851-.537-11.633-9.78-19.877-13.023-30.714-3.395-11.343.254-20.237-11.25-28.188-9.151-6.322-19.432-2.588-28.945-4.915-24.317-5.941-37.602-19.41-55.876 5.034-7.645 10.226-11.1 23.167-19.312 32.43-14.597 16.476-23.693 33.566-4.997 57.019z",
  transform: "translate(-35 -34) rotate(45 101.542 101.491)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#484848",
  fillRule: "nonzero",
  d: "M50.885 0H2.874C1.286 0 0 1.252 0 2.797V93.58c0 1.545 1.286 2.797 2.874 2.797h48.011c1.587 0 2.874-1.252 2.874-2.797V2.797C53.759 1.252 52.472 0 50.885 0z",
  transform: "translate(-35 -34) translate(61 47) translate(30.186)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M3.815 6.876h46.01c.652 0 1.18.514 1.18 1.149v80.328c0 .635-.528 1.15-1.18 1.15H3.815c-.652 0-1.18-.515-1.18-1.15V8.025c0-.635.528-1.15 1.18-1.15z",
  transform: "translate(-35 -34) translate(61 47) translate(30.186)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#606060",
  fillRule: "nonzero",
  d: "M3.462 6.76h46.722c.454 0 .821.355.821.795v2.933H2.635V7.555c0-.212.087-.416.242-.565.156-.15.366-.233.585-.23z",
  transform: "translate(-35 -34) translate(61 47) translate(30.186)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M21.192 4.312c.397 0 .719-.313.719-.7 0-.385-.322-.699-.719-.699-.397 0-.718.314-.718.7 0 .386.321.699.718.699z",
  transform: "translate(-35 -34) translate(61 47) translate(30.186)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-35 -34) translate(61 47) translate(30.186) translate(2.635 10.087)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "fn26zuya7b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#i1nkknq3ta"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#E4EBF7",
  fillRule: "nonzero",
  xlinkHref: "#i1nkknq3ta"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6937",
  d: "M-.489 77.204l13.686-12.767c3.299-3.077 3.288-8.193-.026-11.367-3.313-3.174-8.723-3.253-12.022-.175L-12.407 65.54-.489 77.204zM51.667 77.204L37.981 64.437c-3.299-3.077-3.287-8.193.026-11.367 3.313-3.174 8.723-3.253 12.023-.175L63.585 65.54 51.667 77.204z",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF6937",
  d: "M47.735 51.408c-5.033-1.72-10.823.788-12.88-1.004-1.215-1.06-1.845-5.654-1.845-5.654H17.84s-.274 4.02-1.49 5.08c-2.057 1.792-6.485-.13-11.548.862C-1.162 51.859.93 65.027 3.38 71.406c.565 1.475-.411 4.254.535 6.305.952 2.063 2.4 4.561 2.974 5.897 1.886 4.386 1.498 9.112 2.715 13.091 0 0-1.938 3.635 1.123 5.11h29.397c3.671-1.623 1.121-5.11 1.121-5.11 1.163-3.797.458-6.86 2.18-12.424.344-1.113 1.64-2.875 2.743-5.23 1.722-3.671.92-7.194 1.149-8.084 2.012-7.801 5.934-17.666.418-19.553z",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#725C5A",
  d: "M26.278 43.751c-6.707 2.845-12.365-6.17-14.283-10.022-3.424-6.89-.81-14.8 2.628-16.475 3.148-1.532 6.418.448 6.418.448s5.581 5.117 6.875 15.939c.777 6.475-1.638 10.11-1.638 10.11",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#725C5A",
  d: "M24.745 43.751c6.704 2.845 12.365-6.17 14.282-10.022 3.425-6.89.811-14.8-2.627-16.475-3.148-1.532-6.419.448-6.419.448s-5.58 5.117-6.875 15.939c-.776 6.475 1.64 10.11 1.64 10.11",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#725C5A",
  d: "M24.504 57.58c-4.914 0-8.772-4.064-8.342-8.789l1.123-12.343h14.437l1.123 12.343c.43 4.725-3.427 8.79-8.341 8.79",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#997C79",
  d: "M37.53 26.73c0-12.85-3.196-18.963-13.118-18.963-9.102 0-14.253 6.114-13.08 18.958 0 0 0 6.598 4.42 12.492 1.67 2.228 5.47 4.842 8.75 4.927 3.322.083 6.454-2.04 8.75-5.015 2.468-3.197 4.279-7.478 4.279-12.4",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7C5B4D",
  d: "M24.348 44.297c-1.905 0-4.13-.85-5.807-2.222-.1-.083-.115-.232-.031-.332.083-.1.233-.115.335-.032 1.595 1.305 3.703 2.114 5.503 2.114 1.667 0 4.13-1.063 6.127-2.647.103-.08.253-.065.335.037.082.102.065.25-.037.331-2.108 1.67-4.63 2.751-6.425 2.751",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#665454",
  d: "M26.026 34.636h-2.328c-.24 0-.435-.195-.435-.435s.195-.435.435-.435h1.882l-.173-6.594c-.002-.082.02-.164.063-.235l1.327-2.204c.124-.206.392-.272.597-.148.207.124.273.39.148.597l-1.262 2.095.181 6.913c.003.117-.041.23-.123.315-.082.083-.194.131-.312.131",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E36",
  d: "M27.746 24.522c-.158 0-.312-.072-.394-.2-.121-.189-.043-.426.175-.53 2.413-1.16 6.097-.365 6.252-.33.24.053.387.265.326.474-.063.208-.308.335-.548.281-.035-.007-3.494-.751-5.593.256-.068.034-.144.05-.218.05M20.637 25.579c-.074 0-.15-.016-.22-.05-2.112-1.008-5.389-.264-5.422-.256-.238.058-.49-.067-.556-.275-.066-.207.078-.421.32-.478.147-.035 3.666-.833 6.099.329.22.104.298.341.176.53-.083.127-.237.2-.397.2M31.482 28.673c0 .96-.556 1.736-1.24 1.736-.686 0-1.241-.777-1.241-1.736 0-.958.555-1.735 1.24-1.735.685 0 1.241.777 1.241 1.735M18.145 30.41c-.685 0-1.24-.778-1.24-1.737 0-.958.555-1.735 1.24-1.735.686 0 1.24.777 1.24 1.735 0 .96-.554 1.736-1.24 1.736z",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C44343",
  d: "M24.579 38.108c-1.854 0-3.069-.42-3.144-.448-.261-.093-.403-.398-.32-.684.085-.285.364-.44.624-.35.026.008 2.573.878 5.872-.011.267-.073.535.106.6.398.065.291-.097.586-.363.658-1.212.327-2.323.437-3.27.437",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#665454",
  d: "M24.657 40.221c-.889 0-1.47-.169-1.507-.18-.175-.052-.247-.18-.161-.286.086-.106.296-.15.472-.098.044.013 1.123.317 2.577-.026.181-.04.387.012.457.123.071.11-.019.234-.201.277-.608.143-1.166.19-1.637.19",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E36",
  d: "M45.275 25.372c1.69-4.358-2.988-5.757-2.988-5.757s.159-3.167-2.003-4c.3-4.753-4.354-5.79-4.354-5.79-1.255-3.926-5.819-3.631-6.74-2.6-.352.392-.739 1.092-1.12 1.917 6.474 1.285 8.689 6.804 8.716 16.925.722-.355 1.679-.55 2.46.25 1.227 1.253.116 7.31-4.133 7.61-.622 1.366-1.386 2.612-2.235 3.718-.316.41-.649.804-.997 1.175l.705 7.876c.127 1.412-.153 2.76-.741 3.94 1.198 4.58 6.767 1.636 6.767 1.636s5.064 2.83 7.163-1.595c6.08.742 4.005-6.167 4.005-6.167s4.009-3.052-.256-7.512c2.865-3.463-1.532-6.215-1.532-6.215s1.45-4.222-2.717-5.41z",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E36",
  d: "M19.884 5.7s3.721-3.759 7.278-.121c2.977-1.78 6.036 1.172 5.293 4.69-.755 3.564-3.805 6.548-8.768 5.335-4.63-1.05-6.186.352-5.664 2.224 1.117 4.002-1.489 5.579-1.489 5.579s-1.612 1.576.124 2.91c.975 1.071.057 2.492-.584 3.808-.463.95-.254 2.058.436 2.865.696.814 1.734 2.651 1.116 4.227-.137.346-.019.72.301.919 1.76 1.09 1.388 3.677.344 4.553 2.73 2.91-.744 6.186-.744 6.186s1.2 5.052-3.762 3.759c-1.613 3.516-6.7 3.153-8.065.242-2.976 2.103-8.062-.485-6.822-3.153-4.3-1.132-1.488-5.498-1.488-5.498s-3.307-2.02.165-6.144c-2.729-3.518.497-6.186.497-6.186s-.827-4.648 2.977-5.618c-.828-5.66 2.976-6.469 2.976-6.469s-1.983-5.012 3.474-5.82c.993-5.741 5.127-5.013 5.127-5.013s1.737-4.366 7.278-3.275",
  mask: "url(#fn26zuya7b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#232E36",
  d: "M39.84 18.141c.252-3.582-2.002-4.693-3.88-5.557-1.001-4.077-4.632-3.088-5.382-2.347-2.004-1.977-4.841-1.112-5.593.988-.75 2.099-1.502 4.776 1.92 4.776 0 0 3.86-.69 5.675-.248 1.728.163 0 3.13 2.921 5.023.197.127-.418.741 1.251 3.624.5.86.234 3.364.522 3.437.526.134.562-1.903 1.232-2.285 3.317-1.894 3.088-5.929 1.335-7.41z",
  mask: "url(#fn26zuya7b)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M31.052 3.03h-6.908c-.308 0-.557.243-.557.542v.198c0 .3.25.542.557.542h6.908c.308 0 .557-.243.557-.542v-.198c0-.3-.25-.542-.557-.542z",
  transform: "translate(-35 -34) translate(61 47) translate(30.186)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#997C79",
  d: "M27.207 66.494c4.346-12.852 3.423-35.517 3.423-35.517l-11.104-6.752L.45 61.104c-.338.654-.503 1.384-.435 2.115.446 4.705 4.708 11.372 12.624 8.174 3.594-1.453 6.417-1.898 8.304-1.99 1.677-.082 5.734-1.342 6.264-2.91z",
  transform: "translate(-35 -34) translate(61 47) translate(0 46.656)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#997C79",
  d: "M19.098 25.716S24.59 14.291 29.11 10.305c4.519-3.985 11.066-5.501 17.852-9.249 6.036-3 4.053 4.444-10.273 13.183-3.985 2.43-.184 15.617-9.24 19.126-9.058 3.509-10.328 1.281-8.351-7.649z",
  transform: "translate(-35 -34) translate(61 47) translate(0 46.656)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#725C5A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.5,
  d: "M32.128 8.804s9.178-4.624 14.835-7.747c5.657-3.122 5.68 2.083-1.854 8.064l-7.534 5.98S36.11 28.586 26.369 30.977M29.534 42.157s-4.512.413-6.1-1.012",
  transform: "translate(-35 -34) translate(61 47) translate(0 46.656)"
})))));

var SvgValidationSelfieIcon = function SvgValidationSelfieIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 132,
    viewBox: "0 0 142 132",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgValidationSelfieIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/validation_selfie_icon.1532edac.svg";
export { ForwardRef as ReactComponent };